import React from "react";
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";

import Routes from "./routes";

import "./assets/css/index.css";

ReactDOM.render(
  <React.Fragment>
    <Routes history={browserHistory} />
    <div className="spinner-container" id="loading">
      <div className="loading-spinner"></div>
    </div>
  </React.Fragment>,
  document.getElementById("root")
);
